import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {TextItemSchema} from './textItem'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

export const SupportingContentEnum = z.enum(['Statistics', 'Points', 'Customer Stories'])
export type SupportingContent = z.infer<typeof SupportingContentEnum>
export const CustomerStorySchema = buildEntrySchemaFor('story', {
  fields: z.lazy(() =>
    z.object({
      logo: AssetSchema,
      lead: z.string(),
      url: z.string(),
      title: z.string(),
    }),
  ),
})

export const RiverBreakoutSchema = buildEntrySchemaFor('riverBreakout', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      includeCta: z.boolean().optional(),
      label: z.string().optional(),
      href: z.string().optional(),
      alt: z.string().optional(),
      supportingContent: SupportingContentEnum,
      pointOne: safeOptional(RichTextSchema),
      pointTwo: safeOptional(RichTextSchema),
      pointThree: safeOptional(RichTextSchema),
      statistics: safeOptional(z.array(TextItemSchema)),
      customerStories: safeOptional(z.array(CustomerStorySchema)),
    }),
  ),
})
export type RiverBreakout = z.infer<typeof RiverBreakoutSchema>
